<div class="loading-overlay" *ngIf="loadingService.loading$ | async">
  <div class="spinner"></div>
  <p> Please wait while processing....</p>
</div>
